import Api from './createRelayEnvironment';

export const { environment } = Api.createRelayEnvironment();
